import React, { FC } from 'react'
import styles from 'styles/components/footer.module.scss'
import { FooterSitemapItem } from 'components/Footer'
import { footerMenus } from 'constants/menus'

const FooterSitemap: FC = () => {
  return (
    <ul className={styles.footer__sitemap}>
      {footerMenus.map((menu) => (
        <FooterSitemapItem key={menu.label} label={menu.label} target={menu.target} url={menu.url} />
      ))}
    </ul>
  )
}

export default FooterSitemap
